import { Logger } from '../../utils';
import { useEffect } from 'react';

export default function useHandleTrackPublicationFailed(room, onError) {
  const { localParticipant } = room;
    useEffect(() => {
        const onTrackPublicationFailed = (error, track) => {
            if (error) {
                Logger(`UI.Twilio.TrackPublication.Failed`, new Date(), { "error": error, "track": track }); 
                onError(error);
            }
        };
    if (localParticipant) {
        localParticipant.on('trackPublicationFailed', onTrackPublicationFailed);
      return () => {
          localParticipant.off('trackPublicationFailed', onTrackPublicationFailed);
      };
    }
  }, [localParticipant, onError]);
}
